import React from "react";

export const AuthContext = React.createContext(null);

export const ToastContext = React.createContext(() => {});

export const EventContext = React.createContext(null);
